import { useCallback, useState } from 'react';
import { DateRangePresetKey, DateRangeValue } from '../utils/interface';
import { getPresetRange } from '../utils/attendanceDateRange';

/**
 * Holds the selected preset and date range for a date-range filter. Defaults to "Today";
 * `initial` restores an earlier selection (e.g. when coming back to a page).
 */
export const useDateRangeFilter = (initial?: { preset: DateRangePresetKey; range: DateRangeValue } | null) => {
  const [preset, setPreset] = useState<DateRangePresetKey>(initial?.preset ?? 'today');
  const [range, setRange] = useState<DateRangeValue>(() => initial?.range ?? getPresetRange('today'));

  const changeRange = useCallback((nextPreset: DateRangePresetKey, nextRange: DateRangeValue) => {
    setPreset(nextPreset);
    setRange(nextRange);
  }, []);

  return { preset, range, changeRange };
};
